<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="pt-2">
    <h4>
      {{ 'Settings::VideoPlayerSettings' | abpLocalization }}
    </h4>
    <div class="form-group mt-3">
      <input
        type="checkbox"
        id="playScreenRecordingsIndependently"
        formControlName="playScreenRecordingsIndependently" />
      <label class="ps-1" for="playScreenRecordingsIndependently">
        {{ 'Settings::PlayScreenRecordingsIndependently' | abpLocalization }}
      </label>
    </div>
    <div class="btn-group mt-4">
      <button type="submit" class="btn btn-primary">
        <i class="me-1 fas fa-save"></i>
        <span>
          {{ 'AbpUi::Save' | abpLocalization }}
        </span>
      </button>
    </div>
  </div>
</form>
